//@flow
import React from 'react';
import FiltersActions from '../../Actions/filters';
import Icon from '../../Icon/components/Icon.react';

type Props = {
  checked:boolean,
  name:string,
  text:string,
  children?:React$Node,
};

type State = {
  checked:boolean,
};

export default class Filter extends React.Component<Props, State> {
  state = { checked:false };

  // toggle checkbox when enter or space is pressed
  handleKeyDown = (event:KeyboardEvent) => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.preventDefault(); // prevent scrolling on spacebar press
      this.toggleChecked();
    }
  }

  toggleChecked = () => {
    this.setState({ checked: !this.state.checked });
    FiltersActions.toggleFilter(this.props.name);
  }

  _renderCheck() {
    if (!this.props.checked) return null;
    return <Icon icon="check" size="100%" className="check-icon" />;
  }

  render() {
    return (
      <li>
        <div
          aria-label={this.props.text}
          aria-checked={this.state.checked}
          className="filter"
          onClick={this.toggleChecked}
          onKeyDown={this.handleKeyDown}
          role="checkbox"
          tabIndex="0"
        >
          <span className="filter-checkbox">{this._renderCheck()}</span>
          {this.props.children}
        </div>
      </li>
    );
  }
}
